import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

// 发送短信验证码
export function sendCode(phone) {
  return request({
    url: '/sso/sendCode',
    method: 'post',
    params: { phone }
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/sso/registers',
    method: 'post',
    data: data
  })
}
// 手机验证码登录
export function loginByPhone(phone, code) {
  return request({
    url: '/admin/loginByPhone',
    method: 'post',
    params: { phone, code }
  })
}
//手机验证码找回密码
export function resetPasswordByPhone(data) {
  return request({
    url: '/admin/resetPasswordByPhone',
    method: 'post',
    params: {
      phone: data.phone,
      code: data.code,
      newPassword: data.newPassword
    }
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js